import { inject } from '@angular/core';
import { Observable, map, take } from 'rxjs';

import { CanActivateFn, CanMatchFn } from '@shared/models/guard';
import { UserDetailsFacade } from '@shared/state/facades';

export const canActivateAccountGuard: CanActivateFn = (): Observable<boolean> =>
  hasAccountId();

export const canMatchAccountGuard: CanMatchFn = (): Observable<boolean> =>
  hasAccountId();

const hasAccountId = (): Observable<boolean> => {
  const userDetailsFacade = inject(UserDetailsFacade);

  return userDetailsFacade.query.accountId$.pipe(
    take(1),
    map((accountId) => !!accountId)
  );
};
